import { render, staticRenderFns } from "./ApiCredits.vue?vue&type=template&id=2b451a39&scoped=true"
import script from "./ApiCredits.vue?vue&type=script&lang=js"
export * from "./ApiCredits.vue?vue&type=script&lang=js"
import style0 from "./ApiCredits.vue?vue&type=style&index=0&id=2b451a39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b451a39",
  null
  
)

export default component.exports